import React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from '../../src/components/layout/theme'

export default function TopLayout({ children }) {
  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline>{children}</CssBaseline>
      </ThemeProvider>
    </React.Fragment>
  )
}
